import React from 'react';

/**
 * PageLoader component shown while lazy-loaded pages are being fetched
 * Provides a simple, accessible loading indicator
 */
const PageLoader = () => (
  <div
    className="d-flex justify-content-center align-items-center"
    style={{
      height: '100vh',
      backgroundColor: '#f8f9fa'
    }}
    role="status"
    aria-label="Loading page content"
  >
    <div className="spinner-border" role="status">
      <span className="visually-hidden">Loading...</span>
    </div>
  </div>
);

export default PageLoader;
